(function ($) {
  window.site = site || {};
  site.offers = site.offers || {};
  site.offers.welcome15 = site.offers.welcome15 || {};

  Drupal.behaviors.special_offer_row_promo = {
    attach: function (context, settings) {
      $('.special-offer-button-popup').click(function (e) {
        e.preventDefault();
        Drupal.behaviors.ELB_welcome15.showSignupForm();
      });
    } // attach
  };
})(jQuery);
